import React from 'react';
import { getLocation } from '$utilities/location';

import Button from '$partials/ui/button';
import { IconLinkedIn, IconX } from '$partials/icons';


/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {React.FC<any>}
 */

const ShareButtons = () => {
    const location = getLocation();
    const url = location.href;
    // const twitter = `https://twitter.com/intent/tweet?url=${url}&text=`;
    const linkedin = `https://www.linkedin.com/shareArticle?mini=true&url=${url}`;

    return (
        <div className='flex gap-x-5'>
            <Button
                aria-label='Share to LinkedIn'
                as='a'
                className='button-icon-outcome'
                href={linkedin}
                rel='noreferrer'
                renderIcon={<IconLinkedIn />}
                target='_blank' />
            {/* <Button
                aria-label='Share to X'
                as='a'
                className='button-icon-outcome'
                href={twitter}
                rel='noreferrer'
                renderIcon={<IconX/>}/>
                target='_blank'} */}
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default ShareButtons;
